// import '@uppy/core/dist/style.css'
// import '@uppy/file-input/dist/style.css'

import proportional from '../../../../node_modules/shido.proportional.js/src/proportional.js'

const Uppy = require('@uppy/core')
const FileInput = require('@uppy/file-input')
const XHRUpload = require('@uppy/xhr-upload')

const DeleteImg = () => {
  const deleteImages = document.querySelectorAll('.gallery-img-container a')

  if (!deleteImages.length > 0) return

  deleteImages.forEach((deleteImg) => {
    deleteImg.addEventListener('click', (e) => {
      e.preventDefault()

      axios.delete(deleteImg.getAttribute('href'))
      .then(function (response) {
        deleteImg.closest('.gallery-img').remove()
      })
      .catch(function (error) {
        // ...
      })
    })
  })
}
const DeleteUppyImg = (a) => {
  a.addEventListener('click', (e) => {
    e.preventDefault()

    axios.delete(a.getAttribute('href'))
    .then(function (response) {
      a.closest('.gallery-img').remove()
    })
    .catch(function (error) {
      // ...
    })
  })
}

const UppyFiles = () => {
  const uppyForms = document.querySelectorAll('[uppy-form]')

  if (!uppyForms.length > 0) return

  DeleteImg()

  uppyForms.forEach((uppyForm) => {
    const token = document.head.querySelector('meta[name="csrf-token"]')
    const uppy = new Uppy({ debug: true, autoProceed: true })
    const target = uppyForm.getAttribute('id')
    const uploadFiles = document.querySelector(`#${target}-uploaded-files`)

    uppy.use(FileInput, {
      target: `#${target}`,
      replaceTargetContent: true,
      pretty: true,
      locale: {
        strings: {
          chooseFiles: uppyForm.getAttribute('text-button')
        }
      }
    })

    uppy.use(XHRUpload, {
      headers: {
        'X-CSRF-TOKEN': token.content
      },
      endpoint: uppyForm.getAttribute('action'),
      fieldName: uppyForm.getAttribute('name'),
      method: uppyForm.getAttribute('method'),
      limit: 0
    })

    uppy.on('upload-success', (file, response) => {
      const imgContainer = document.createElement('div')
      const galleryImgContainer = document.createElement('div')
      const deleteImg = document.createElement('a')

      imgContainer.classList.add('x:scol-6', 's:scol-3', 'x:top', 'gallery-img')
      galleryImgContainer.classList.add('gallery-img-container', 'bg-img-cover')

      deleteImg.href = `${uppyForm.getAttribute('action')}/${response.body.photo.id}`
      galleryImgContainer.style.backgroundImage = `url(${response.body.photo.url})`
      galleryImgContainer.setAttribute('proportional', 'square, static')

      galleryImgContainer.appendChild(deleteImg)
      imgContainer.appendChild(galleryImgContainer)
      uploadFiles.appendChild(imgContainer)

      new proportional().init()

      DeleteUppyImg(deleteImg)
    })
  })
}
export default UppyFiles
